import request from '../utils/request';
import { withClinicContext } from '../utils/impersonationContext';
/**
 * Get all saved payment methods for the current user.
 * If an admin is ordering for a clinic (see ImpersonationContext), fetches that clinic's
 * payment methods instead.
 */
export function getPaymentMethods() {
    const url = withClinicContext('/api/v1/payment-methods/');
    return request().get(url).send();
}
/**
 * Create a new saved payment method
 * This will create a payment customer on first use or attach to an existing one
 */
export function createPaymentMethod(data) {
    const url = withClinicContext('/api/v1/payment-methods/');
    return request().post(url).send(data);
}
/**
 * Fetch payment methods for a specific clinic (admin only)
 */
export function getClinicPaymentMethods(clinicId) {
    return request().get(`/api/v1/payment-methods/clinic/${clinicId}/`).send();
}
/**
 * Fetch Stripe frontend config for tokenized card setup.
 */
export function getStripeConfig() {
    return request().get('/api/v1/payments/stripe/config/').send();
}
